import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetCompoundRecordComposerDocument,
  type GetCompoundRecordComposerQuery,
  type GetCompoundRecordComposerQueryVariables,
} from "~/features/compoundRecordComposers/gqls";
import { useTenant } from "~/features/tenant/context";

export function useComposerDetail(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");

  return useSuspenseQuery<GetCompoundRecordComposerQuery, GetCompoundRecordComposerQueryVariables>(
    GetCompoundRecordComposerDocument,
    {
      variables: {
        tenantId,
        where: { id: { _eq: id } },
      },
    },
  );
}
